import React from 'react';
import "./Navbar.css";
import { Link } from 'react-router-dom';
import { ReactComponent as Icon1 } from './github-icon1.svg';
import { ReactComponent as Icon2 } from './linkedin-icon1.svg';
import { ReactComponent as Icon3 } from './mail1.svg';
import './Footer.css'
export default function Footer() {

{/* <Link className="navbar-brand" to="/">© 2025 Avry Jackson</Link> */}

  return (
    <div className= "container-navbar">

          <div className = "logo-container">
              <Link className="home-link" to="/">© 2025 Avry Jackson</Link>

          </div>

      {/* <div className= "navbar-item-container">
                <div className = "items-nav">
                  <Link to = "/" className= "middle-link-text"> Home</Link>
                  <Link to = "/projects" className = "middle-link-text">Projects</Link> */}
                  {/* <Link to = "/notes" className = "middle-link-text"> Notes</Link> */}

                {/* </div> */}
          {/* </div> */}

          <div className = "nav-social-links">
                <a className = "socail-icon-link" href="https://github.com/avryjacksoncom" ><Icon1 className = "logo-settings"></Icon1></a>
                <a href = "https://www.linkedin.com/in/avry-jackson-886529265/"><Icon2 className = "logo-settings"></Icon2></a>
                <a href = "mailto:ljackson175@toromail.csudh.edu" ><Icon3 className = "logo-settings"></Icon3></a>
          </div>
   
   
   
   
   
    </div>


  );
}
